import { BREAKPOINT } from '@/constants/enum';
import styled from 'styled-components';

export const CheckoutStyled = styled.div`
  .wrap-header-icon {
    background-color: var(--p-color-bg-fill-info);
    padding: 4px;
    border-radius: 8px;
    margin-right: 0.5rem;
  }
  .checkout-feedback {
    width: unset !important;
    height: 135px;
    object-fit: contain;
  }
  .Polaris-IndexTable .Polaris-IndexTable__TableCell {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media (min-width: ${BREAKPOINT.MD}px) {
    .checkout-feedback {
      width: 279px !important;
    }
  }
`;
